import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ExpenseForm from "@components/forms/ExpensesInvoiceForm";

const ExpenseAddEdit = () => {
  const params = useParams()
  const { id: providerInvoiceId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerInvoiceId ? 'Agregar' : 'Editar'} Gasto`}
      backUrl="/user/expenses"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerInvoiceForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ExpenseForm
        formId="providerInvoiceForm"
        id={providerInvoiceId}
        saveRedirectUrl="/user/expenses"
      ></ExpenseForm>

    </PageContainer>
  );
}

export default ExpenseAddEdit;
